<template>
    <modal
        class="flex-modal flex-modal--prompt"
        :title="prompt.title"
        :hide-header-close="true"
    >
        <div class="flex-modal__description">
            {{ prompt.description }}
        </div>

        <template v-slot:modal-footer>
            <button class="flex-modal__button flex-modal__button--cancel" @click="onCancel">
                Cancel
            </button>

            <button class="flex-modal__button flex-modal__button--continue" @click="onContinue">
                Continue
            </button>
        </template>
    </modal>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import { HIDE_PROMPT } from '@/store/types/mutation-types';

export default {
    computed: {
        ...mapState({
            prompt: state => state.prompt,
        }),
    },

    created() {
        this.$keydown('enter', this.onContinue);
        this.$keydown('escape', this.onCancel);
    },

    destroyed() {
        this.$keydown();
    },

    methods: {
        ...mapMutations({
            hidePrompt: HIDE_PROMPT,
        }),

        onContinue() {
            this.prompt.onContinue();
            this.hidePrompt();
        },

        onCancel() {
            this.prompt.onCancel();
            this.hidePrompt();
        },
    },
};
</script>
